import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "app/services/authentication.service";
import { Baseservice } from "app/services/baseservice";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AdminAnnualComplianceService extends Baseservice {
  protected url: string = environment.iCBMSWebApi.url;
  protected filterUrl: string = environment.iCBMSWebApi.url;
  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("permit-type", http, authentication);
  }

  getAllByFilter(keyword: any, PageNum: number, PageSize: number) {
    return this.http.post(
      `${this.url}compliance/search/${PageNum}/${PageSize}`,
      keyword
    );
  }

  downloadpdf(id) {
    return this.http
      .get(this.url + "document/download/" + id, { responseType: "blob" })
      .pipe(
        map((res: any) => {
          return new Blob([res], { type: "application/pdf" });
        })
      );
  }

  getAdminAnnualCompList(PageNum: number, PageSize: number) {
    return this.http.get(
      `${this.url}compliance/getComplianceCertificates/${PageNum}/${PageSize}`
    );
  }

  viewPermitDetails(id: any) {
    return this.http.get(this.url + "compliance/GetComplianceByCompId/" + id);
  }

  getPermitDocumentList(id: any) {
    return this.http.get(this.url + "document/permit-doc-list/" + id);
  }

  getPermitData(id: any) {
    return this.http.get(this.url + "application/find/" + id);
  }

  onRejectStatus(id: any, UserName :string) {
    return this.http.get(this.url + "compliance/rejected/" + `${id}/${UserName}`);
  }
  onApprovedStatus(id: any, isDuplicate: boolean, UserName :string) {
    return this.http.get(
      this.url + "compliance/approve/" + `${id}/${isDuplicate}/${UserName}`
    );
  }
  onHoldStatus(id: any, UserName :string) {
    return this.http.get(this.url + "compliance/onhold/" + `${id}/${UserName}`);
  }

  changeStatus(complianceid, body) {
    return this.http.post(
      `${this.url}compliance/changestatus/${complianceid}`,
      body
    );
  }
  sendEmail(body: any) {
    return this.http.post(`${this.url}compliance/adminemail`, body);
  }

  printAnnualComplianceCertificate(body: any) {
    return this.http
      .post(this.url + "permit/download/print/compliance/v2", body, {
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
